import { GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../../recoil/atoms/missingInformationAtom';
import { allCoverablesAtom } from '../../../../../recoil/atoms/allCoverablesAtom';
import HouseMissingInformationForm from './HouseMissingInformationForm';
import { COVERABLE_CODE } from '../../../../../constants/coverable';

const HouseMissingInformation = (): React.JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { privateHouse } = missingInformation;
    const allCoverables = useRecoilValue(allCoverablesAtom);
    const hasHouseFlavour = allCoverables.houses !== undefined && allCoverables.houses.length > 0;
    const hasHolidayHomeFlavour =
        allCoverables.holidayHomes !== undefined && allCoverables.holidayHomes.length > 0;
    if (!privateHouse?.length || (!hasHouseFlavour && !hasHolidayHomeFlavour)) return <></>;

    return (
        <GridItem span={12}>
            {privateHouse
                .filter((missingInformation) => !!missingInformation.fixedId)
                .map((missingInformation) => {
                    const currentCoverableList =
                        missingInformation.flavourCode === COVERABLE_CODE.prhHouse
                            ? allCoverables.houses
                            : allCoverables.holidayHomes;
                    if (!currentCoverableList) return <></>;

                    const currentCoverableIndex =
                        currentCoverableList?.findIndex(
                            (coverable) => coverable.fixedId === missingInformation.fixedId
                        ) ?? -1;

                    return (
                        <div
                            className="u-spacing-inset-m--stretch-max"
                            key={missingInformation.fixedId}
                        >
                            <HouseMissingInformationForm
                                currentCoverable={currentCoverableList[currentCoverableIndex]}
                                houseMissingDTO={missingInformation}
                            />
                        </div>
                    );
                })}
        </GridItem>
    );
};

export default HouseMissingInformation;
